import { useCallback } from 'react';
import ClientId from '~/constants/ClientId';
import didSetNativeAppCapabilities from '~/constants/common/didSetNativeAppCapabilities';
import { getAppCapabilitiesCookieName } from '~/native/utils';
import BrowserCookies from '~/utilities/BrowserCookies';

export default function useSetNativeAppCapabilities(clientId: ClientId) {
  return useCallback(
    (capabilities: string[]) => {
      if (capabilities.length === 0) return false;

      const didSetNativeAppCapabilitiesCookieName =
        didSetNativeAppCapabilities[clientId];

      if (didSetNativeAppCapabilitiesCookieName) {
        BrowserCookies.set(
          getAppCapabilitiesCookieName(clientId),
          capabilities.join(',')
        );
        BrowserCookies.set(didSetNativeAppCapabilitiesCookieName, 'true');
      }

      return true;
    },
    [clientId]
  );
}
